import { Suspense } from 'react'
import { AsyncLoaderPopup } from '../../components/async-loader/async-loader-popup'
import ProjectMenuListRoot from './components/project-menu-list-root'
import { ProjectMenuContainer } from './styled-component'
import ProjectMenuHeader from './components/project-menu-header'
import { getLicense } from '../../react-query/authentication/query/use-me-query'
import { Route, Switch, useHistory, useLocation } from 'react-router-dom'
import ProjectSettings from '../ProjectSettings'
import CopyProjectModal from '../../components/copy-project-modal'
import CreateProjectModal from './components/create-project-modal'
import UpgradePlanPopup from '../UpgradePlanPopup'
import MoveProjectModal from './components/move-items-modals/move-project-modal'
import MoveFoldertModal from './components/move-items-modals/move-folder-modal'
import CreateFolderModalWrapper from './components/create-folder-modal'
import ProjectRenameFolderModalWrapper from './components/project-rename-folder-modal'
import { DateTime } from 'luxon'
import { useGetProjectLimitQuery } from '../../react-query/project/query/use-get-project-limit-query'
import ProjectInfoPanel from '../../components/project-info-panel'
import ProjectMenuMobile from './components/project-menu-mobile'
import { useIsMobile } from '../../zustand/browser-store/use-browser-store'

const ProjectMenu = () => {
  const location = useLocation()
  const params = new URLSearchParams(location.search)
  const isMobile = useIsMobile()

  const viewType = params.get('view')

  const history = useHistory()
  const { data: canCreateProject, isLoading: isProjectLimitLoading } =
    useGetProjectLimitQuery()
  const license = getLicense()

  const projectLimitReached =
    canCreateProject === false ||
    !license ||
    license.type === 'None' ||
    (license.until &&
      Number(DateTime.fromISO(license.until).toFormat('yyyyMMdd')) <
        Number(DateTime.now().toFormat('yyyyMMdd')))

  const closeCreateProjectPopup = () => history.goBack()

  if (isMobile) return <ProjectMenuMobile />

  return (
    <ProjectMenuContainer>
      {/* modals */}

      <Suspense fallback={<AsyncLoaderPopup />}>
        <Switch>
          <Route path="/project/settings/:projectId">
            <ProjectSettings />
          </Route>
          {isProjectLimitLoading && (
            <Route path="/project/:projectId/copy">
              <AsyncLoaderPopup />
            </Route>
          )}
          {isProjectLimitLoading && (
            <Route path="/project/new/:parentId?">
              <AsyncLoaderPopup />
            </Route>
          )}
          {!isProjectLimitLoading && !projectLimitReached && (
            <Route path="/project/:projectId/copy">
              <CopyProjectModal />
            </Route>
          )}
          {!isProjectLimitLoading && !projectLimitReached && (
            <Route path="/project/new/:parentId?">
              <Suspense fallback={<AsyncLoaderPopup />}>
                <CreateProjectModal />
              </Suspense>
            </Route>
          )}
          {!isProjectLimitLoading && projectLimitReached && (
            <Route path="/project/:projectId/copy">
              <Suspense fallback={<AsyncLoaderPopup />}>
                <UpgradePlanPopup close={closeCreateProjectPopup} />
              </Suspense>
            </Route>
          )}
          {!isProjectLimitLoading && projectLimitReached && (
            <Route path="/project/new/:parentId?">
              <Suspense fallback={<AsyncLoaderPopup />}>
                <UpgradePlanPopup close={closeCreateProjectPopup} />
              </Suspense>
            </Route>
          )}
          <Route path="/project/move/project/:projectId" exact>
            <Suspense fallback={<AsyncLoaderPopup />}>
              <MoveProjectModal />
            </Suspense>
          </Route>

          <Route path="/project/move/folder/:folderId" exact>
            <Suspense fallback={<AsyncLoaderPopup />}>
              <MoveFoldertModal />
            </Suspense>
          </Route>

          <Route
            path={['/project/newfolder', '/project/newfolder/:parentId?']}
            exact
          >
            <Suspense fallback={<AsyncLoaderPopup />}>
              <CreateFolderModalWrapper />
            </Suspense>
          </Route>
          <Route path="/project/renameFolder/:id">
            <ProjectRenameFolderModalWrapper />
          </Route>

          <Route path="/project/info/:projectId">
            <ProjectInfoPanel />
          </Route>
        </Switch>
      </Suspense>

      {/* Project menu view */}
      <ProjectMenuHeader />
      <ProjectMenuListRoot viewType={viewType} />
    </ProjectMenuContainer>
  )
}

export default ProjectMenu
